// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar.css */

nav {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 103%;
  max-width: 100vw;
  box-sizing: border-box;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
  overflow: visible;
}

nav .title {
  font-size: 28px;
  text-decoration: none;
  margin-left: 10px;
  margin-top: 19px;
  font-family: Georgia, "Times New Roman", Times, serif;
}

nav .title:hover {
  cursor: pointer;
}

nav ul {
  display: flex;
  margin-right: 20px;
  margin-left: 60px;
}

.img {
  display: flex;
  align-items: center;
}

nav ul li {
  list-style: none;
  display: block;
  text-decoration: none;
  padding: 3px;
  margin-right: 15px;
  font-size: 18px;
  color: #7c7c7c;
}

nav ul li:hover {
  cursor: pointer;
  color: #79c6e9;
}

nav ul li a {
  text-decoration: none;
  color: #7c7c7c;
  display: flex;
  align-items: center;
}

nav ul li a:hover {
  cursor: pointer;
  color: #79c6e9;
}

.icon {
  font-size: 25px;
}

.iconFace {
  font-size: 25px;
  padding-right: 20px;
  flex-shrink: 0;
  position: relative;
  z-index: 1100;
}

.helpDropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  overflow-y: auto;
  z-index: 1100;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 15px;
  right: 0;
  left: auto;
  top: calc(100% + 8px);
}

.helpDropdown-content.show {
  display: block;
}

.helpDropdown-content a {
  font-size: 14px;
  display: block;
  text-align: left;
}

.helpDropdown-content a:hover {
  background-color: #e7f2ff;
}

.userDropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  overflow-y: auto;
  z-index: 1100;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 15px;
  right: 0;
  left: auto;
  top: calc(100% + 8px);
  height: 320px;
}

.userDropdown-content.show {
  display: block;
}

.userDropdown-content a {
  font-size: 17px;
  display: block;
  text-align: left;
  padding-top: 5px;
}

.userDropdown-content a:hover {
  background-color: #e7f2ff;
}

.userDropdown-content .userAndCompanyName {
  text-align: center;
  padding-bottom: 4px;
}

.userDropdown-content .userAndCompanyNamee {
  text-align: center;
  font-size: 26px;
  padding-bottom: 2px;
  padding-top: 3px;
}

.userDropdown-contentt {
  display: none;
  position: absolute;
  background-color: white;
  overflow-y: auto;
  z-index: 1100;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 15px;
  right: 0;
  left: auto;
  top: calc(100% + 8px);
  height: auto;
}

.userDropdown-contentt.show {
  display: block;
}

.userDropdown-contentt a {
  font-size: 17px;
  display: block;
  text-align: left;
  padding-top: 5px;
}

.userDropdown-contentt a:hover {
  background-color: #e7f2ff;
}

.userDropdown-contentt .userAndCompanyName {
  text-align: center;
  padding-bottom: 4px;
}

.userDropdown-contentt .userAndCompanyNamee {
  text-align: center;
  font-size: 26px;
  padding-bottom: 2px;
  padding-top: 3px;
}

hr.darkHR {
  background-color: black;
  height: 0.5px;
  border: none;
  margin-left: -5px;
  margin-right: -5px;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 5px;
  background: none;
  border: none;
  color: #888;
  font-size: 25px;
  cursor: pointer;
}

.callUsPopup {
  width: 100%;
  height: 100%;
  text-align: center;
}

.callText {
  text-align: center;
  width: 350px;
  height: 30px;
}

.feedbackButtons {
  display: flex;
  justify-content: right;
  padding-bottom: 30px;
  padding-right: 30px;
}

.close-btn:hover {
  color: #000;
}

.link-content {
  display: flex;
  align-items: center;
}

.referralsbox {
  padding-left: 0;
  padding-right: 0;
}

.socialMedia {
  border: 1px solid #ccc;
  border-radius: 20px;
  margin: 40px 20px 20px 20px;
  height: 130px;
  padding: 20px;
  text-align: center;
}

.referalMessage .socialMedia p {
  margin-top: 0px; /* or whatever value you prefer */
}

.referalMessage .socialMedia div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.socialMediaIcons {
  padding: 10px;
  background-color: #ccc;
  border-radius: 20px;
  margin: 20px 10px 20px 10px;
  cursor: pointer;
  font-size: 40px;
}

.iconDi {
  font-size: 18px;
  margin-top: 2px;
  /* margin-bottom: 6px; */
  margin-right: 8px; /* Adjust spacing between the icon and the text */
}

.loggedInUser {
  text-align: center;
}

@media (max-width: 768px) {
  .helpDropdown-content,
  .userDropdown-content,
  .userDropdown-contentt {
    right: 0;
    left: auto;
    top: calc(100% + 8px);
  }
}

.active-link {
  font-weight: bold;
  color: #79c6e9; /* Example color for active link */
  border-bottom: 2px solid #79c6e9; /* Example of an underline for the active link */
}

.referalMessage p {
  padding-left: 25px;
  padding-right: 25px;
  margin-top: 20px;
  font-size: 16px;
}

.socialMediaButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

/* ─── Polished account/help menus ─────────────────────────────────────────── */
.userDropdown-content,
.userDropdown-contentt {
  width: 280px;
  max-height: 280px;
  height: 280px;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
  background: #ffffff;
  overflow-y: auto;
  right: 0;
  left: auto;
  top: calc(100% + 8px);
  z-index: 1100;
}

.userDropdown-contentt {
  height: auto;
  max-height: 280px;
}

.userDropdown-content.show,
.userDropdown-contentt.show {
  display: block;
}

.userDropdown-content li,
.userDropdown-contentt li {
  list-style: none;
  margin: 1px 0;
  padding: 0;
}

.userDropdown-content a,
.userDropdown-contentt a,
.userDropdown-content .link-button,
.userDropdown-contentt .link-button {
  width: 100%;
  border: 0;
  background: transparent;
  color: #334155;
  display: block;
  text-align: left;
  text-decoration: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  font: inherit;
}

.userDropdown-content a:hover,
.userDropdown-contentt a:hover,
.userDropdown-content .link-button:hover,
.userDropdown-contentt .link-button:hover {
  background: #f0f9ff;
  color: #0369a1;
}

.link-content {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  min-height: 32px;
  box-sizing: border-box;
}

.link-text {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.iconDi {
  font-size: 15px;
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin: 0;
  margin-right: 0;
  color: #64748b;
}

.userDropdown-content a:hover .iconDi,
.userDropdown-contentt a:hover .iconDi,
.userDropdown-content .link-button:hover .iconDi,
.userDropdown-contentt .link-button:hover .iconDi {
  color: #0284c7;
}

.userDropdown-content .userAndCompanyNamee,
.userDropdown-contentt .userAndCompanyNamee {
  margin: 0;
  padding: 2px 0 0;
  text-align: center;
  font-size: 18px;
  color: #0f172a;
}

.userDropdown-content .userAndCompanyName,
.userDropdown-contentt .userAndCompanyName {
  margin: 2px 0 0;
  padding: 0 6px 2px;
  text-align: center;
  font-size: 15px;
  color: #64748b;
  line-height: 1.3;
}

hr.darkHR {
  background: #e2e8f0;
  height: 1px;
  border: none;
  margin: 5px 2px;
}

/* ─── Referrals dialog ────────────────────────────────────────────────────── */
.referrals-dialog .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.45) !important;
}

.referrals-paper {
  width: 440px !important;
  max-width: calc(100vw - 32px) !important;
  border-radius: 16px !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;
  background: #fff !important;
}

.referrals-header {
  position: relative;
  text-align: center;
  padding: 28px 28px 18px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.referrals-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #64748b !important;
}

.referrals-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin: 0 auto 14px;
  border-radius: 14px;
  background: #eef8fe;
  color: #07a6ef;
  font-size: 1.45rem;
}

.referrals-heading {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.referrals-sub {
  margin: 10px auto 0;
  max-width: 340px;
  font-size: 0.9rem;
  color: #64748b;
  line-height: 1.55;
}

.referrals-sub strong {
  color: #0f172a;
  font-weight: 600;
}

.referrals-body {
  padding: 20px 24px 26px;
  text-align: center;
}

.referrals-share-label {
  margin: 0 0 14px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.referrals-socials {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.referrals-social-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #f1f5f9;
  color: #0f172a;
  font-size: 1.25rem;
  text-decoration: none;
  transition:
    background 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;
}

.referrals-social-btn:hover {
  background: #07a6ef;
  color: #fff;
  transform: translateY(-1px);
}

.socialMediaButton {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

/* ─── FAQ dialog ──────────────────────────────────────────────────────────── */
.faq-dialog .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.45) !important;
}

.faq-paper {
  width: 640px !important;
  max-width: calc(100vw - 32px) !important;
  max-height: calc(100vh - 48px) !important;
  border-radius: 16px !important;
  padding: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;
  background: #fff !important;
}

.faq-header {
  position: relative;
  flex-shrink: 0;
  text-align: center;
  padding: 22px 48px 16px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.faq-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #64748b !important;
}

.faq-heading {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.faq-sub {
  margin: 6px auto 0;
  max-width: 380px;
  font-size: 0.84rem;
  color: #64748b;
  line-height: 1.45;
}

.faq-body {
  padding: 12px 16px 20px;
  overflow-y: auto;
  background: #f8fafc;
}

.faq-accordion {
  margin: 0 0 8px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  background: #fff !important;
  overflow: hidden;
}

.faq-accordion::before {
  display: none !important;
}

.faq-accordion-summary {
  min-height: 48px !important;
  padding: 0 14px !important;
}

.faq-accordion-summary .MuiAccordionSummary-content {
  margin: 12px 0 !important;
  font-size: 0.92rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.faq-accordion-details {
  padding: 0 16px 14px !important;
  font-size: 0.88rem;
  color: #475569;
  line-height: 1.55;
  border-top: 1px solid #f1f5f9;
}

.faq-accordion-details ul {
  margin: 8px 0 0;
  padding-left: 1.15rem;
}

.faq-accordion-details li {
  margin: 4px 0;
}

/* ─── Talk to Us ──────────────────────────────────────────────────────────── */
.talk-to-us-dialog .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.45) !important;
}

.callUsPopup .MuiPaper-root,
.talk-to-us-paper {
  width: 400px !important;
  max-width: calc(100vw - 32px) !important;
  border-radius: 16px !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;
  background: #fff !important;
}

.talk-to-us-header {
  position: relative;
  text-align: center;
  padding: 22px 48px 16px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.talk-to-us-heading {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.25;
  text-align: center;
}

.talk-to-us-sub {
  margin: 6px auto 0;
  font-size: 0.84rem;
  color: #64748b;
  line-height: 1.45;
  max-width: 280px;
  text-align: center;
}

.talk-to-us-close {
  position: absolute !important;
  top: 14px;
  right: 12px;
  color: #64748b !important;
}

.talk-to-us-body {
  padding: 18px 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.talk-to-us-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}

.talk-to-us-section-label {
  margin: 0 0 2px 2px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.talk-to-us-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  text-decoration: none;
  color: inherit;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.talk-to-us-row:hover {
  border-color: #07a6ef;
  background: #f0f9ff;
  box-shadow: 0 0 0 3px rgba(7, 166, 239, 0.1);
}

.talk-to-us-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #eef8fe;
  color: #07a6ef;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}

.talk-to-us-row-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.talk-to-us-row-label {
  font-size: 0.72rem;
  font-weight: 500;
  color: #64748b;
  line-height: 1.2;
}

.talk-to-us-row-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: 0.01em;
  line-height: 1.3;
  word-break: break-word;
}

.callText {
  width: auto;
  height: auto;
  min-height: 0;
  text-align: center;
  color: #334155;
  line-height: 1.7;
  margin: 6px 0;
  font-size: 15px;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 14px;
  background: none;
  border: none;
  color: #64748b;
  font-size: 24px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

.close-btn:hover {
  color: #000;
}

.feedbackButtons {
  justify-content: flex-end;
  padding: 16px 24px 24px;
}

/* ─── Send Feedback ───────────────────────────────────────────────────────── */
.feedback-dialog .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.45) !important;
}

.feedback-dialog .MuiPaper-root,
.feedback-paper {
  width: 480px !important;
  max-width: calc(100vw - 32px) !important;
  border-radius: 16px !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;
  background: #fff !important;
}

.feedback-header {
  position: relative;
  text-align: center;
  padding: 22px 48px 16px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.feedback-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #64748b !important;
}

.feedback-heading {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.feedback-sub {
  margin: 6px auto 0;
  max-width: 340px;
  font-size: 0.84rem;
  color: #64748b;
  line-height: 1.45;
}

.feedback-body {
  padding: 18px 22px 8px;
}

.feedback-label {
  display: block;
  margin: 0 0 8px 2px;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}

.feedback-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 12px 22px 22px;
}

.feedback-btn-secondary {
  text-transform: none !important;
  font-weight: 600 !important;
  color: #334155 !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 10px !important;
  padding: 7px 14px !important;
}

.feedback-btn-primary {
  text-transform: none !important;
  font-weight: 600 !important;
  background: #07a6ef !important;
  border-radius: 10px !important;
  padding: 7px 16px !important;
  box-shadow: none !important;
}

.feedback-btn-primary:hover {
  background: #0596d8 !important;
}

/* 
Media Query for screens smaller than 600px */
@media (max-width: 900px) {
  nav {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    width: 103%;
    max-width: 100vw;
    box-sizing: border-box;
    z-index: 1000;
    background-color: white;
    border: 1px solid #ccc;
  }
  nav .title {
    font-size: 20px;
    text-decoration: none;
    margin-left: 5px;
    margin-top: 18px;
    font-family: Georgia, "Times New Roman", Times, serif;
  }
  nav ul li {
    list-style: none;
    display: block;
    text-decoration: none;
    padding: 3px;
    margin-right: 15px;
    font-size: 15px;
    color: #7c7c7c;
    padding-top: 5px;
  }
}

/* ─── Under Construction / Coming Soon ────────────────────────────────────── */
.under-construction-dialog .MuiBackdrop-root {
  background-color: rgba(15, 23, 42, 0.45) !important;
}

.under-construction-paper {
  width: 400px !important;
  max-width: calc(100vw - 32px) !important;
  border-radius: 16px !important;
  padding: 0 !important;
  overflow: hidden !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;
  background: #fff !important;
}

.under-construction-header {
  position: relative;
  text-align: center;
  padding: 28px 28px 8px;
}

.under-construction-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #64748b !important;
}

.under-construction-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin: 0 auto 14px;
  border-radius: 14px;
  background: #eef8fe;
  color: #07a6ef;
  font-size: 1.65rem;
}

.under-construction-heading {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.under-construction-sub {
  margin: 10px auto 0;
  max-width: 300px;
  font-size: 0.9rem;
  color: #64748b;
  line-height: 1.5;
}

.under-construction-actions {
  display: flex;
  justify-content: center;
  padding: 20px 24px 24px;
}

.under-construction-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  background: #07a6ef !important;
  border-radius: 10px !important;
  padding: 8px 22px !important;
  min-width: 120px;
  box-shadow: none !important;
}

.under-construction-btn:hover {
  background: #0596d8 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Css/Navbar.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,iCAAiC;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,iBAAiB,EAAE,iDAAiD;AACtE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;;IAGE,QAAQ;IACR,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,kCAAkC;EAClD,gCAAgC,EAAE,gDAAgD;AACpF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA,gFAAgF;AAChF;;EAEE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA;;;;EAIE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB;;;wBAGsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,yCAAyC;EACzC,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,mDAAmD;AACrD;;AAEA;;EAEE,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd;;;yBAGuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF;EACE,mDAAmD;AACrD;;AAEA;;EAEE,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;4CAC4C;AAC5C;EACE;IACE,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,qDAAqD;EACvD;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,gFAAgF;AAChF;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* Navbar.css */\n\nnav {\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  justify-content: space-between;\n  align-items: center;\n  height: 50px;\n  width: 103%;\n  max-width: 100vw;\n  box-sizing: border-box;\n  z-index: 1000;\n  background-color: white;\n  border: 1px solid #ccc;\n  overflow: visible;\n}\n\nnav .title {\n  font-size: 28px;\n  text-decoration: none;\n  margin-left: 10px;\n  margin-top: 19px;\n  font-family: Georgia, \"Times New Roman\", Times, serif;\n}\n\nnav .title:hover {\n  cursor: pointer;\n}\n\nnav ul {\n  display: flex;\n  margin-right: 20px;\n  margin-left: 60px;\n}\n\n.img {\n  display: flex;\n  align-items: center;\n}\n\nnav ul li {\n  list-style: none;\n  display: block;\n  text-decoration: none;\n  padding: 3px;\n  margin-right: 15px;\n  font-size: 18px;\n  color: #7c7c7c;\n}\n\nnav ul li:hover {\n  cursor: pointer;\n  color: #79c6e9;\n}\n\nnav ul li a {\n  text-decoration: none;\n  color: #7c7c7c;\n  display: flex;\n  align-items: center;\n}\n\nnav ul li a:hover {\n  cursor: pointer;\n  color: #79c6e9;\n}\n\n.icon {\n  font-size: 25px;\n}\n\n.iconFace {\n  font-size: 25px;\n  padding-right: 20px;\n  flex-shrink: 0;\n  position: relative;\n  z-index: 1100;\n}\n\n.helpDropdown-content {\n  display: none;\n  position: absolute;\n  background-color: white;\n  overflow-y: auto;\n  z-index: 1100;\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 15px;\n  right: 0;\n  left: auto;\n  top: calc(100% + 8px);\n}\n\n.helpDropdown-content.show {\n  display: block;\n}\n\n.helpDropdown-content a {\n  font-size: 14px;\n  display: block;\n  text-align: left;\n}\n\n.helpDropdown-content a:hover {\n  background-color: #e7f2ff;\n}\n\n.userDropdown-content {\n  display: none;\n  position: absolute;\n  background-color: white;\n  overflow-y: auto;\n  z-index: 1100;\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 15px;\n  right: 0;\n  left: auto;\n  top: calc(100% + 8px);\n  height: 320px;\n}\n\n.userDropdown-content.show {\n  display: block;\n}\n\n.userDropdown-content a {\n  font-size: 17px;\n  display: block;\n  text-align: left;\n  padding-top: 5px;\n}\n\n.userDropdown-content a:hover {\n  background-color: #e7f2ff;\n}\n\n.userDropdown-content .userAndCompanyName {\n  text-align: center;\n  padding-bottom: 4px;\n}\n\n.userDropdown-content .userAndCompanyNamee {\n  text-align: center;\n  font-size: 26px;\n  padding-bottom: 2px;\n  padding-top: 3px;\n}\n\n.userDropdown-contentt {\n  display: none;\n  position: absolute;\n  background-color: white;\n  overflow-y: auto;\n  z-index: 1100;\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n  padding: 12px 16px;\n  border-radius: 10px;\n  font-size: 15px;\n  right: 0;\n  left: auto;\n  top: calc(100% + 8px);\n  height: auto;\n}\n\n.userDropdown-contentt.show {\n  display: block;\n}\n\n.userDropdown-contentt a {\n  font-size: 17px;\n  display: block;\n  text-align: left;\n  padding-top: 5px;\n}\n\n.userDropdown-contentt a:hover {\n  background-color: #e7f2ff;\n}\n\n.userDropdown-contentt .userAndCompanyName {\n  text-align: center;\n  padding-bottom: 4px;\n}\n\n.userDropdown-contentt .userAndCompanyNamee {\n  text-align: center;\n  font-size: 26px;\n  padding-bottom: 2px;\n  padding-top: 3px;\n}\n\nhr.darkHR {\n  background-color: black;\n  height: 0.5px;\n  border: none;\n  margin-left: -5px;\n  margin-right: -5px;\n}\n\n.close-btn {\n  position: absolute;\n  top: 20px;\n  right: 5px;\n  background: none;\n  border: none;\n  color: #888;\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.callUsPopup {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n\n.callText {\n  text-align: center;\n  width: 350px;\n  height: 30px;\n}\n\n.feedbackButtons {\n  display: flex;\n  justify-content: right;\n  padding-bottom: 30px;\n  padding-right: 30px;\n}\n\n.close-btn:hover {\n  color: #000;\n}\n\n.link-content {\n  display: flex;\n  align-items: center;\n}\n\n.referralsbox {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.socialMedia {\n  border: 1px solid #ccc;\n  border-radius: 20px;\n  margin: 40px 20px 20px 20px;\n  height: 130px;\n  padding: 20px;\n  text-align: center;\n}\n\n.referalMessage .socialMedia p {\n  margin-top: 0px; /* or whatever value you prefer */\n}\n\n.referalMessage .socialMedia div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.socialMediaIcons {\n  padding: 10px;\n  background-color: #ccc;\n  border-radius: 20px;\n  margin: 20px 10px 20px 10px;\n  cursor: pointer;\n  font-size: 40px;\n}\n\n.iconDi {\n  font-size: 18px;\n  margin-top: 2px;\n  /* margin-bottom: 6px; */\n  margin-right: 8px; /* Adjust spacing between the icon and the text */\n}\n\n.loggedInUser {\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .helpDropdown-content,\n  .userDropdown-content,\n  .userDropdown-contentt {\n    right: 0;\n    left: auto;\n    top: calc(100% + 8px);\n  }\n}\n\n.active-link {\n  font-weight: bold;\n  color: #79c6e9; /* Example color for active link */\n  border-bottom: 2px solid #79c6e9; /* Example of an underline for the active link */\n}\n\n.referalMessage p {\n  padding-left: 25px;\n  padding-right: 25px;\n  margin-top: 20px;\n  font-size: 16px;\n}\n\n.socialMediaButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n/* ─── Polished account/help menus ─────────────────────────────────────────── */\n.userDropdown-content,\n.userDropdown-contentt {\n  width: 280px;\n  max-height: 280px;\n  height: 280px;\n  padding: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);\n  background: #ffffff;\n  overflow-y: auto;\n  right: 0;\n  left: auto;\n  top: calc(100% + 8px);\n  z-index: 1100;\n}\n\n.userDropdown-contentt {\n  height: auto;\n  max-height: 280px;\n}\n\n.userDropdown-content.show,\n.userDropdown-contentt.show {\n  display: block;\n}\n\n.userDropdown-content li,\n.userDropdown-contentt li {\n  list-style: none;\n  margin: 1px 0;\n  padding: 0;\n}\n\n.userDropdown-content a,\n.userDropdown-contentt a,\n.userDropdown-content .link-button,\n.userDropdown-contentt .link-button {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: #334155;\n  display: block;\n  text-align: left;\n  text-decoration: none;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0;\n  font: inherit;\n}\n\n.userDropdown-content a:hover,\n.userDropdown-contentt a:hover,\n.userDropdown-content .link-button:hover,\n.userDropdown-contentt .link-button:hover {\n  background: #f0f9ff;\n  color: #0369a1;\n}\n\n.link-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  min-height: 32px;\n  box-sizing: border-box;\n}\n\n.link-text {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.iconDi {\n  font-size: 15px;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n  margin: 0;\n  margin-right: 0;\n  color: #64748b;\n}\n\n.userDropdown-content a:hover .iconDi,\n.userDropdown-contentt a:hover .iconDi,\n.userDropdown-content .link-button:hover .iconDi,\n.userDropdown-contentt .link-button:hover .iconDi {\n  color: #0284c7;\n}\n\n.userDropdown-content .userAndCompanyNamee,\n.userDropdown-contentt .userAndCompanyNamee {\n  margin: 0;\n  padding: 2px 0 0;\n  text-align: center;\n  font-size: 18px;\n  color: #0f172a;\n}\n\n.userDropdown-content .userAndCompanyName,\n.userDropdown-contentt .userAndCompanyName {\n  margin: 2px 0 0;\n  padding: 0 6px 2px;\n  text-align: center;\n  font-size: 15px;\n  color: #64748b;\n  line-height: 1.3;\n}\n\nhr.darkHR {\n  background: #e2e8f0;\n  height: 1px;\n  border: none;\n  margin: 5px 2px;\n}\n\n/* ─── Referrals dialog ────────────────────────────────────────────────────── */\n.referrals-dialog .MuiBackdrop-root {\n  background-color: rgba(15, 23, 42, 0.45) !important;\n}\n\n.referrals-paper {\n  width: 440px !important;\n  max-width: calc(100vw - 32px) !important;\n  border-radius: 16px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;\n  background: #fff !important;\n}\n\n.referrals-header {\n  position: relative;\n  text-align: center;\n  padding: 28px 28px 18px;\n  border-bottom: 1px solid #eef2f7;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n}\n\n.referrals-close {\n  position: absolute !important;\n  top: 12px;\n  right: 12px;\n  color: #64748b !important;\n}\n\n.referrals-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  margin: 0 auto 14px;\n  border-radius: 14px;\n  background: #eef8fe;\n  color: #07a6ef;\n  font-size: 1.45rem;\n}\n\n.referrals-heading {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.referrals-sub {\n  margin: 10px auto 0;\n  max-width: 340px;\n  font-size: 0.9rem;\n  color: #64748b;\n  line-height: 1.55;\n}\n\n.referrals-sub strong {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.referrals-body {\n  padding: 20px 24px 26px;\n  text-align: center;\n}\n\n.referrals-share-label {\n  margin: 0 0 14px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.referrals-socials {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.referrals-social-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  background: #f1f5f9;\n  color: #0f172a;\n  font-size: 1.25rem;\n  text-decoration: none;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease,\n    transform 0.15s ease;\n}\n\n.referrals-social-btn:hover {\n  background: #07a6ef;\n  color: #fff;\n  transform: translateY(-1px);\n}\n\n.socialMediaButton {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n/* ─── FAQ dialog ──────────────────────────────────────────────────────────── */\n.faq-dialog .MuiBackdrop-root {\n  background-color: rgba(15, 23, 42, 0.45) !important;\n}\n\n.faq-paper {\n  width: 640px !important;\n  max-width: calc(100vw - 32px) !important;\n  max-height: calc(100vh - 48px) !important;\n  border-radius: 16px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  display: flex !important;\n  flex-direction: column !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;\n  background: #fff !important;\n}\n\n.faq-header {\n  position: relative;\n  flex-shrink: 0;\n  text-align: center;\n  padding: 22px 48px 16px;\n  border-bottom: 1px solid #eef2f7;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n}\n\n.faq-close {\n  position: absolute !important;\n  top: 12px;\n  right: 12px;\n  color: #64748b !important;\n}\n\n.faq-heading {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.faq-sub {\n  margin: 6px auto 0;\n  max-width: 380px;\n  font-size: 0.84rem;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.faq-body {\n  padding: 12px 16px 20px;\n  overflow-y: auto;\n  background: #f8fafc;\n}\n\n.faq-accordion {\n  margin: 0 0 8px !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 12px !important;\n  background: #fff !important;\n  overflow: hidden;\n}\n\n.faq-accordion::before {\n  display: none !important;\n}\n\n.faq-accordion-summary {\n  min-height: 48px !important;\n  padding: 0 14px !important;\n}\n\n.faq-accordion-summary .MuiAccordionSummary-content {\n  margin: 12px 0 !important;\n  font-size: 0.92rem;\n  font-weight: 600;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.faq-accordion-details {\n  padding: 0 16px 14px !important;\n  font-size: 0.88rem;\n  color: #475569;\n  line-height: 1.55;\n  border-top: 1px solid #f1f5f9;\n}\n\n.faq-accordion-details ul {\n  margin: 8px 0 0;\n  padding-left: 1.15rem;\n}\n\n.faq-accordion-details li {\n  margin: 4px 0;\n}\n\n/* ─── Talk to Us ──────────────────────────────────────────────────────────── */\n.talk-to-us-dialog .MuiBackdrop-root {\n  background-color: rgba(15, 23, 42, 0.45) !important;\n}\n\n.callUsPopup .MuiPaper-root,\n.talk-to-us-paper {\n  width: 400px !important;\n  max-width: calc(100vw - 32px) !important;\n  border-radius: 16px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;\n  background: #fff !important;\n}\n\n.talk-to-us-header {\n  position: relative;\n  text-align: center;\n  padding: 22px 48px 16px;\n  border-bottom: 1px solid #eef2f7;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n}\n\n.talk-to-us-heading {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  text-align: center;\n}\n\n.talk-to-us-sub {\n  margin: 6px auto 0;\n  font-size: 0.84rem;\n  color: #64748b;\n  line-height: 1.45;\n  max-width: 280px;\n  text-align: center;\n}\n\n.talk-to-us-close {\n  position: absolute !important;\n  top: 14px;\n  right: 12px;\n  color: #64748b !important;\n}\n\n.talk-to-us-body {\n  padding: 18px 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.talk-to-us-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.talk-to-us-section-label {\n  margin: 0 0 2px 2px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.talk-to-us-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n  text-decoration: none;\n  color: inherit;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.talk-to-us-row:hover {\n  border-color: #07a6ef;\n  background: #f0f9ff;\n  box-shadow: 0 0 0 3px rgba(7, 166, 239, 0.1);\n}\n\n.talk-to-us-icon {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: #eef8fe;\n  color: #07a6ef;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.15rem;\n}\n\n.talk-to-us-row-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.talk-to-us-row-label {\n  font-size: 0.72rem;\n  font-weight: 500;\n  color: #64748b;\n  line-height: 1.2;\n}\n\n.talk-to-us-row-value {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #0f172a;\n  letter-spacing: 0.01em;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.callText {\n  width: auto;\n  height: auto;\n  min-height: 0;\n  text-align: center;\n  color: #334155;\n  line-height: 1.7;\n  margin: 6px 0;\n  font-size: 15px;\n}\n\n.close-btn {\n  position: absolute;\n  top: 16px;\n  right: 14px;\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 24px;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n}\n\n.close-btn:hover {\n  color: #000;\n}\n\n.feedbackButtons {\n  justify-content: flex-end;\n  padding: 16px 24px 24px;\n}\n\n/* ─── Send Feedback ───────────────────────────────────────────────────────── */\n.feedback-dialog .MuiBackdrop-root {\n  background-color: rgba(15, 23, 42, 0.45) !important;\n}\n\n.feedback-dialog .MuiPaper-root,\n.feedback-paper {\n  width: 480px !important;\n  max-width: calc(100vw - 32px) !important;\n  border-radius: 16px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;\n  background: #fff !important;\n}\n\n.feedback-header {\n  position: relative;\n  text-align: center;\n  padding: 22px 48px 16px;\n  border-bottom: 1px solid #eef2f7;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n}\n\n.feedback-close {\n  position: absolute !important;\n  top: 12px;\n  right: 12px;\n  color: #64748b !important;\n}\n\n.feedback-heading {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.feedback-sub {\n  margin: 6px auto 0;\n  max-width: 340px;\n  font-size: 0.84rem;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.feedback-body {\n  padding: 18px 22px 8px;\n}\n\n.feedback-label {\n  display: block;\n  margin: 0 0 8px 2px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.feedback-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 22px 22px;\n}\n\n.feedback-btn-secondary {\n  text-transform: none !important;\n  font-weight: 600 !important;\n  color: #334155 !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 10px !important;\n  padding: 7px 14px !important;\n}\n\n.feedback-btn-primary {\n  text-transform: none !important;\n  font-weight: 600 !important;\n  background: #07a6ef !important;\n  border-radius: 10px !important;\n  padding: 7px 16px !important;\n  box-shadow: none !important;\n}\n\n.feedback-btn-primary:hover {\n  background: #0596d8 !important;\n}\n\n/* \nMedia Query for screens smaller than 600px */\n@media (max-width: 900px) {\n  nav {\n    display: flex;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    justify-content: space-between;\n    align-items: center;\n    height: 50px;\n    width: 103%;\n    max-width: 100vw;\n    box-sizing: border-box;\n    z-index: 1000;\n    background-color: white;\n    border: 1px solid #ccc;\n  }\n  nav .title {\n    font-size: 20px;\n    text-decoration: none;\n    margin-left: 5px;\n    margin-top: 18px;\n    font-family: Georgia, \"Times New Roman\", Times, serif;\n  }\n  nav ul li {\n    list-style: none;\n    display: block;\n    text-decoration: none;\n    padding: 3px;\n    margin-right: 15px;\n    font-size: 15px;\n    color: #7c7c7c;\n    padding-top: 5px;\n  }\n}\n\n/* ─── Under Construction / Coming Soon ────────────────────────────────────── */\n.under-construction-dialog .MuiBackdrop-root {\n  background-color: rgba(15, 23, 42, 0.45) !important;\n}\n\n.under-construction-paper {\n  width: 400px !important;\n  max-width: calc(100vw - 32px) !important;\n  border-radius: 16px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;\n  background: #fff !important;\n}\n\n.under-construction-header {\n  position: relative;\n  text-align: center;\n  padding: 28px 28px 8px;\n}\n\n.under-construction-close {\n  position: absolute !important;\n  top: 12px;\n  right: 12px;\n  color: #64748b !important;\n}\n\n.under-construction-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  margin: 0 auto 14px;\n  border-radius: 14px;\n  background: #eef8fe;\n  color: #07a6ef;\n  font-size: 1.65rem;\n}\n\n.under-construction-heading {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.under-construction-sub {\n  margin: 10px auto 0;\n  max-width: 300px;\n  font-size: 0.9rem;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.under-construction-actions {\n  display: flex;\n  justify-content: center;\n  padding: 20px 24px 24px;\n}\n\n.under-construction-btn {\n  text-transform: none !important;\n  font-weight: 600 !important;\n  background: #07a6ef !important;\n  border-radius: 10px !important;\n  padding: 8px 22px !important;\n  min-width: 120px;\n  box-shadow: none !important;\n}\n\n.under-construction-btn:hover {\n  background: #0596d8 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
